export const accountInfoQueryKeys = {
  getAccountInfo: '/v2/accountInfo',
  createAccountInfo: '/v2/accountInfo',
  validateAccountInfo: '/v2/accountInfo/validate',
} as const;
